var map = {
  "./ru-RU.cjs": [
    "83395",
    9,
    "8835"
  ],
  "./es-ES.cjs": [
    "53789",
    9,
    "9293"
  ],
  "./en-CA.cjs": [
    "94886",
    9,
    "8360"
  ],
  "./fr-FR.cjs": [
    "67781",
    9,
    "2869"
  ],
  "./en-US.cjs": [
    "37770",
    9,
    "9156"
  ],
  "./es-AR.cjs": [
    "29752",
    9,
    "1938"
  ],
  "./ja-JP.cjs": [
    "87074",
    9,
    "7852"
  ],
  "./de-DE.cjs": [
    "75323",
    9,
    "7179"
  ],
  "./ko-KR.cjs": [
    "99324",
    9,
    "270"
  ],
  "./th-TH.cjs": [
    "77430",
    9,
    "2801"
  ],
  "./common/index.cjs": [
    "76454",
    7,
    "8718"
  ],
  "./id-ID.cjs": [
    "38051",
    9,
    "2307"
  ],
  "./en-GB.cjs": [
    "6521",
    9,
    "2881"
  ],
  "./pt-BR.cjs": [
    "87229",
    9,
    "8781"
  ],
  "./it-IT.cjs": [
    "56995",
    9,
    "1251"
  ],
  "./es-419.cjs": [
    "73969",
    9,
    "1769"
  ],
  "./en-IN.cjs": [
    "6195",
    9,
    "8723"
  ],
  "./hi-IN.cjs": [
    "80819",
    9,
    "979"
  ],
  "./en-AU.cjs": [
    "9776",
    9,
    "8666"
  ],
  "./tr-TR.cjs": [
    "13477",
    9,
    "3957"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[2]).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 43976;
module.exports = __rspack_async_context;
